import React from "react";
import { Modal, Spin } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";

const PaymentProcessingModal = ({
  visible,
  status = "processing",
  message = "",
  error = "",
  onClose,
  rounded = true,
}) => {
  return (
    <Modal
      visible={visible}
      closable={status !== "processing"}
      footer={null}
      onCancel={onClose}
      centered
      maskClosable={false}
      bodyStyle={{ padding: "24px" }}
      className={rounded ? "rounded-modal" : ""}
      style={{ borderRadius: rounded ? "16px" : undefined, overflow: "hidden" }}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        {status === "processing" && (
          <>
            <Spin size="large" />
            <div style={{ marginTop: 20, fontSize: 18, fontWeight: 500 }}>
              {message}
            </div>
          </>
        )}

        {status === "success" && (
          <>
            <div style={{ marginBottom: 20 }}>
              <img 
                src="https://dev.beclutch.club/images/powered-by-beclutch.png" 
                alt="BeClutch" 
                style={{ maxWidth: 200, height: "auto" }}
              />
            </div>
            <div style={{ fontSize: 48, color: "#52c41a", marginBottom: 16 }}>✓</div>
            <div style={{ fontSize: 18, fontWeight: 500, color: "#52c41a", marginBottom: 20 }}>
              {message}
            </div>
            <div style={{ 
              fontSize: 14, 
              color: "#ff8c00", 
              fontWeight: 500,
              padding: "12px",
              background: "#fff3e0",
              borderRadius: "4px",
              marginTop: 16
            }}>
              Important Note: Charges will appear on your statement as "BECLUTCH"
            </div>
          </>
        )}

        {status === "error" && (
          <>
            <div style={{ fontSize: 48, color: "#ff4d4f", marginBottom: 16 }}>✕</div>
            <div style={{ fontSize: 18, fontWeight: 500, color: "#ff4d4f", marginBottom: 12 }}>
              {message}
            </div>
            {error && (
              <div
                style={{
                  fontSize: 14,
                  color: "#666",
                  padding: "12px",
                  background: "#f5f5f5",
                  borderRadius: "4px",
                  wordBreak: "break-word",
                }}
              >
                {error}
              </div>
            )}
            <div style={{ marginTop: 20 }}>
              <CommonButton onClick={onClose} style={{ backgroundColor: "#1890ff" }}>
                Close
              </CommonButton>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default PaymentProcessingModal;
